// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.bcf2478e.css";
	// return url for filenames based on template
	return "" + chunkId + "." + "a2a197ac" + ".chunk.css";
};